// ---------------------------------------------------------------------------
// app/utils/googleAuth.js
//
// Google Sign-In has been REMOVED from JobEng.
//
// The native package (@react-native-google-signin/google-signin) is no longer
// installed. This stub exists only so the auth screens that still import
// `googleSignIn` continue to bundle. Calling it reports that Google login is
// unavailable; every caller already wraps the call in try/catch and shows an
// alert, so nothing crashes.
//
// To fully remove Google from the UI, delete the Google buttons and their
// handlers from these screens, then delete this file:
//   - app/screens/professional/ProfessionalLoginScreen.js   (already done)
//   - app/screens/professional/ProfessionalSignupScreen.js
//   - app/screens/learning/LearningLoginScreen.js
//   - app/screens/learning/LearningSignupScreen.js
// ---------------------------------------------------------------------------

export async function googleSignIn() {
  const error = new Error('Google Sign-In is no longer available in JobEng.');
  error.cancelled = false;
  error.code = 'GOOGLE_SIGNIN_REMOVED';
  throw error;
}

export default { googleSignIn };
